export default __webpack_public_path__ + "static/media/th.b4262644.svg";